window.isFrenzyEventApiCall = true;
const frenzy_get_product_json = async function(url, html){
  jQuery.getJSON(url, function(product) {
    document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
      const getVariantID = this_section.getAttribute("data-variantid");
      const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
      const max_price = product.price_max;
      const min_price = product.price_min;
      var compare_price = '';
      var price = '<span> Starting at: </span>' + money_format_Frenzy(min_price, frenzy_shop_currency);
      this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
      this_section.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
      this_section.querySelector('.frenzy_product_price_compare').style.display = 'none';
    });
  })
}
window.FrenzyProductGridChangeCallBack = function(html,data){
   html.querySelector('.frenzy_product_price_meta').classList.add("FrenzyProductId_"+data.product_id);
  if(data?.sale != "on sale"){
    if(html.querySelector('.frenzy_product_tags')){
      html.querySelector('.frenzy_product_tags .frenzy_tag.sale_tag').style.display = 'none';
    }
  }
  if(data?.sale === "on sale"){
    html.querySelector('.frenzy_product_tags .frenzy_tag.sale_tag').style.display = 'block';
    const product_handle = data.org_prod_url.split("?");
    frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html).then(frenzy_product_response => {return frenzy_product_response});
  }
};
